import Vue from 'vue'
import axios from 'axios'
import { Message } from 'element-ui'
let loadings = ''

function getAxios (settings, timeout = 90000) {
  const ins = axios.create(settings)
  if (timeout) {
    ins.defaults.timeout = timeout
  }
  ins.defaults.method = 'GET'
  ins.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
  ins.defaults.headers.put['Content-Type'] = 'application/json;charset=utf-8'
  setInterceptors(ins, settings.loading, settings.closeError, settings.limit)
  return ins
}

function setInterceptors (axiosIns, loading = true, closeError = false, limit = true) {
  axiosIns.interceptors.request.use(
    req => {
      // 是否开启 loading
      if (loading) {
        loadings = Vue.prototype.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }
      return req
    },
    error => {
      return Promise.reject(error)
    }
  )
  axiosIns.interceptors.response.use(
    res => {
      // console.log('已结束:', res)
      loadings.close && loadings.close()
      // console.error(JSON.stringify(res), '########')

      if (limit) {
        // 未登录
        if (res.data.errorCode == '401' || res.data.code == '401') {
          window.location.href = res.data.redirect_url
          return false
        }
        // 没有权限
        if (res.data.errorCode == '403' || res.data.code == '403') {
          Message({
            message: '您没有此操作权限，请联系管理员开通。',
            type: 'error',
            duration: 2000
          })
          return Promise.reject(res.data)
        }

        if (res.data && (res.data.status == 0 || res.data.code == 1 || res.data.errorCode == 0)) {
          return res.data
        }
        if (res.data.code == 0) {
          Vue.prototype.$message({
            message: res.data.msg,
            type: 'error',
            duration: 5000
          })
        }
      } else {
        return res.data
      }

      return Promise.reject(res.data)
    },
    error => {
      loadings.close && loadings.close()
      if (!closeError) {
        Vue.prototype.$message({
          message: error.message || error.msg,
          type: 'error',
          duration: 5000
        })
      }
      return Promise.reject(error)
    }
  )
}

export default getAxios
